<template>
  <div :class="containerClass">
    <section class="desc" data-aos="fade-in" data-aos-duration="300">
      <h5 :class="step" class="h5-cls">
        {{ step }}
      </h5>
      <h2 class="title">
        {{ title }}
      </h2>
      <div class="description normal-font" v-html="description">
      </div>
      <div v-if="$mq !== 'desktop'" class="img-desc">
        <img v-lazy-load :data-src="image" />
      </div>
    </section>
    <div
      v-if="$mq === 'desktop'"
      class="img-desc"
      data-aos="fade-left"
      data-aos-duration="600"
    >
      <img v-lazy-load :data-src="image" />
    </div>
  </div>
</template>
<script>
import deviceMixin from "~/mixins/deviceMixin";

export default {
  mixins: [deviceMixin],
  props: {
    title: String,
    description: String,
    image: String,
    step: String,
    id: String
  },
  computed: {
    containerClass() {
      switch (this.$mq) {
        case "desktop":
          return "skills-boost column--duo--equivalent";
        case "tablet":
          return "skills-boost single";
        default:
          return "skills-boost single mobile";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.skills-boost {
  padding: 4rem 1.4rem;

  .desc {
    .title {
      margin-bottom: 1rem;
    }
    .h5-cls {
      color: #0062cc;
      font-size: 18px;
      font-weight: 700;
      line-height: 18px;
    }
  }

  .img-desc {
    display: flex;
    img {
      margin: auto;
      max-height: 250px;
      max-width: 420px;
    }
  }
}
.skills-boost.column--duo--equivalent {
  padding: 4rem 1.4rem;
  .desc {
    .title {
      font-weight: 800;
      font-size: 36px;
      line-height: 36px;
      letter-spacing: -1px;
    }

    .description-2 {
      max-width: 85%;
    }
    .description {
      font-weight: 600;
      font-size: 18px;
      line-height: 23.54px;
      letter-spacing: 0.03px;
      text-justify: inter-character;
    }
  }
}

.skills-boost.single.mobile {
  padding: 2rem 1.4rem;

  .title {
    font-weight: 800;
    font-size: 32px;
    line-height: 32px;
    letter-spacing: -0.8px;
    color: black;
    margin-bottom: 1rem;
  }
  .description {
    font-weight: 600;
    font-size: 18px;
    line-height: 23.54px;
    letter-spacing: 0.03px;
    text-justify: inter-character;
    margin-bottom: 1rem;
  }
  .img-desc {
    display: flex;
    img {
      margin: auto;
      max-height: 250px;
      max-width: 100%;
    }
  }
}

.skills-boost.single {
  padding: 4rem 1.4rem;

  .title {
    font-weight: 800;
    font-size: 36px;
    line-height: 36px;
    letter-spacing: -1px;
    margin-bottom: 1rem;
  }
  .description {
    font-weight: 600;
    font-size: 18px;
    line-height: 23.54px;
    letter-spacing: 0.03px;
    text-justify: inter-character;
    margin-bottom: 2rem;
  }
}
</style>
